import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  options: {
    responsive: true,
    // Mantém proporção para evitar distorção ("esticado") em containers largos/altos.
    maintainAspectRatio: true,
    // ~2.2:1 costuma ficar com cara de dashboard (largo, mas sem achatar o gráfico)
    aspectRatio: 2.2,
    scales: {
      xAxes: [{
        ticks: { fontColor: "#000", fontSize:9},
      }],
      yAxes: [{
        ticks: {fontColor: "#000", fontSize:9},
      }]
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}